export const EMAILJS_SERVICE_ID = "service_32uc2lr";
export const EMAILJS_TEMPLATE_ID = "template_d0djsjx";
export const EMAILJS_USER_ID = "qzlXcJV9U0FxbS3nE";
